import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';
import Pagination from '@components/@core/Pagination';
import { UserRoles } from '~/services/config';

class Report extends React.PureComponent {
    state = { current: 1, per: 25 };

    handleClick = (e) => () => {
        if (this.props.userRole > UserRoles.MANAGER) return;
        if (this.props.companyId < 0) {
            this.props.onCompany(e);
        } else {
            this.props.navigate({
                pathname: `/hcm/report-training/${this.props.companyId}/${e.id}`,
                state: {
                    user: {
                        id: e.id,
                        name: e.name,
                        profile: { avatar: e.avatar },
                    },
                },
            });
        }
    };

    handlePagination = (e) => {
        this.props.onPage(e, this.state.per);
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.props.onPage(this.state.current, e);
        this.setState({ per: e });
    };

    render() {
        const { current, per } = this.state;
        const { total, data, type, mode } = this.props;
        const totalPage = Math.ceil(data[mode].total / data[mode].per_page);
        const selected = mode === 'individual' ? data[mode].individuals : data[mode].companies;

        if (!total) return null;
        return (
            <>
                <div className="report-item mt-3 desktop-screen">
                    <div className="d-flex-3 text-start text-400 mb-2">
                        <p className="dsl-m12 text-400">Employees</p>
                    </div>
                    <div className="d-flex ssm-column d-flex-7 ps-0 ssp-l-5">
                        <div className="d-flex-2 text-end mb-2">
                            <p className="dsl-m12 mb-1 text-400">Assigned</p>
                            <p className="dsl-m12 mb-1 text-400">Courses</p>
                        </div>
                        <div className="d-flex-2 text-end mb-2">
                            <p className="dsl-m12 mb-1 text-400">Incomplete</p>
                            <p className="dsl-m12 mb-1 text-400">Courses</p>
                        </div>
                        <div className="d-flex-2 text-end mb-2">
                            <p className="dsl-m12 mb-1 text-400">Past Due</p>
                            <p className="dsl-m12 mb-1 text-400">Courses</p>
                        </div>
                        <div className="d-flex-2 text-end mb-2">
                            <p className="dsl-m12 mb-1 text-400">Completed</p>
                            <p className="dsl-m12 mb-1 text-400">Courses</p>
                        </div>
                        <div className="d-flex-2 text-end mb-2">
                            <p className="dsl-m12 mb-1 text-400">Completed</p>
                            <p className="dsl-m12 mb-1 text-400">on time</p>
                        </div>
                        <div className="d-flex-2 text-end mb-2">
                            <p className="dsl-m12 mb-1 text-400">Completed</p>
                            <p className="dsl-m12 mb-1 text-400">past due</p>
                        </div>
                    </div>
                </div>
                <div className="report-item d-flex ssm-column py-0 py-md-3">
                    <div className="title d-flex-3 mb-0 mb-md-3 py-2 py-sm-0">
                        <span className="dsl-b14 mb-0 text-400">Total</span>
                    </div>
                    <div className="d-flex ssm-column d-flex-7 ps-0 ssp-l-5">
                        <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                            <label className="dsl-b14 mobile-screen d-flex-1 text-start">Assigned Courses</label>
                            <p className="dsl-b14 me-0 ssm-r-2 mb-0 text-400">{total?.courses_assigned?.count}</p>
                            <p className="dsl-m12 mb-0 text-400">{total?.courses_assigned?.percent}%</p>
                        </div>
                        <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                            <label className="dsl-b14 mobile-screen d-flex-1 text-start">Incomplete Courses</label>
                            <p className="dsl-b14 mb-0 me-0 ssm-r-2 text-400">{total?.courses_incompleted?.count}</p>
                            <p className="dsl-m12 mb-0 text-400">{total?.courses_incompleted?.percent}%</p>
                        </div>
                        <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                            <label className="dsl-b14 mobile-screen d-flex-1 text-start">Past Due Courses</label>
                            <p className="dsl-b14 mb-0 me-0 ssm-r-2 text-400">{total?.courses_past_due?.count}</p>
                            <p className="dsl-m12 mb-0 text-400">{total?.courses_past_due?.percent}%</p>
                        </div>
                        <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                            <label className="dsl-b14 mobile-screen d-flex-1 text-start">Completed Courses</label>
                            <p className="dsl-b14 mb-0 me-0 ssm-r-2 text-400">{total?.courses_completed?.count}</p>
                            <p className="dsl-m12 mb-0 text-400">{total?.courses_completed?.percent}%</p>
                        </div>
                        <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                            <label className="dsl-b14 mobile-screen d-flex-1 text-start">Completed on time</label>
                            <p className="dsl-b14 mb-0 me-0 ssm-r-2 text-400">{total?.courses_completed_on_time?.count}</p>
                            <p className="dsl-m12 mb-0 text-400">{total?.courses_completed_on_time?.percent}%</p>
                        </div>
                        <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                            <label className="dsl-b14 mobile-screen d-flex-1 text-start">Completed past due</label>
                            <p className="dsl-b14 mb-0 me-0 ssm-r-2 text-400">{total?.courses_completed_past_due?.count}</p>
                            <p className="dsl-m12 mb-0 text-400">{total?.courses_completed_past_due?.percent}%</p>
                        </div>
                    </div>
                </div>
                {selected.map((item) => {
                    const { id, name, avatar, report } = item;
                    return (
                        <div className="report-item hover d-flex ssm-column py-0 py-md-3 text-400" key={id}>
                            <div className="d-flex-3 d-flex ai-center py-2 py-sm-0">
                                <Avatar name={name} url={avatar} />
                                <span className="dsl-b14 ms-3 cursor-pointer text-400" onClick={this.handleClick(item)}>
                                    {name}
                                </span>
                            </div>
                            <div className="d-flex ssm-column d-flex-7 ps-0 ssp-l-5">
                                <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                                    <label className="d-flex-1 dsl-b14 mobile-screen text-start">Assigned Courses</label>
                                    <p className="dsl-b14 mb-0 ssm-r-2 me-0 text-400">{report[type].courses_assigned.count}</p>
                                    <p className="dsl-m12 mb-0 text-400">{report[type].courses_assigned.percent}%</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                                    <label className="d-flex-1 dsl-b14 mobile-screen text-start">Incomplete Courses</label>
                                    <p className="dsl-b14 mb-0 ssm-r-2 me-0 text-400">{report[type].courses_incompleted.count}</p>
                                    <p className="dsl-m12 mb-0 text-400">{report[type].courses_incompleted.percent}%</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                                    <label className="d-flex-1 dsl-b14 mobile-screen text-start">Past Due Courses</label>
                                    <p className="dsl-b14 mb-0 ssm-r-2 me-0 text-400">{report[type].courses_past_due.count}</p>
                                    <p className="dsl-m12 mb-0 text-400">{report[type].courses_past_due.percent}%</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                                    <label className="d-flex-1 dsl-b14 mobile-screen text-start">Completed Courses</label>
                                    <p className="dsl-b14 mb-0 ssm-r-2 me-0 text-400">{report[type].courses_completed.count}</p>
                                    <p className="dsl-m12 mb-0 text-400">{report[type].courses_completed.percent}%</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                                    <label className="d-flex-1 dsl-b14 mobile-screen text-start">Completed on time</label>
                                    <p className="dsl-b14 mb-0 ssm-r-2 me-0 text-400">{report[type].courses_completed_on_time.count}</p>
                                    <p className="dsl-m12 mb-0 text-400">{report[type].courses_completed_on_time.percent}%</p>
                                </div>
                                <div className="d-flex-2 d-flex flex-column ssm-row text-end">
                                    <label className="d-flex-1 dsl-b14 mobile-screen text-start">Completed past due</label>
                                    <p className="dsl-b14 mb-0 ssm-r-2 me-0 text-400">{report[type].courses_completed_past_due.count}</p>
                                    <p className="dsl-m12 mb-0 text-400">{report[type].courses_completed_past_due.percent}%</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
                <Pagination current={current} per={per} total={totalPage} onChange={this.handlePagination} onPer={this.handlePer} />
            </>
        );
    }
}

Report.propTypes = {
    type: PropTypes.string,
    userRole: PropTypes.number,
    total: PropTypes.any,
    data: PropTypes.object,
    history: PropTypes.any,
};

Report.defaultProps = {
    type: 'metrics',
    userRole: 1,
    total: {},
    data: {},
    history: {},
};

export default Report;
